<template>
  <div id="fm_index">
    <div class="top">
      <van-swipe :autoplay="3000" class="my-swipe">
        <van-swipe-item v-for="(image, index) in topImages" :key="index">
          <a :href="image.url">
            <van-image width="100%" fit="cover" lazy-load :src="image.src" />
          </a>
        </van-swipe-item>
      </van-swipe>
    </div>

    <div class="dianbo">
      <div class="title">节目点播</div>
      <div class="items">
        <van-grid
          :border="false"
          :column-num="4"
          :gutter="5"
          square
          icon-size="50px"
        >
          <van-grid-item
            v-for="(v, k) in programs"
            :key="k"
            :url="v.url"
            class="item"
            :text="v.name"
            :icon="v.src"
          >
            <!-- <van-image lazy-load fit="cover" :src="v.src" /> -->
            <!-- <div class="name">{{ v.name }}</div> -->
          </van-grid-item>
        </van-grid>
      </div>
    </div>

    <div class="activity">
      <van-tabs v-model="active">
        <van-tab title="精彩活动">
          <div class="items">
            <van-row
              type="flex"
              class="item van-hairline--top-bottom"
              v-for="(v, k) in activies"
              :key="k"
              @click="redirect(v.url)"
            >
              <van-col span="8" class="left">
                <van-image lazy-load fit="cover" :src="v.src"></van-image>
              </van-col>
              <van-col span="16" class="right">
                <div class="title">
                  {{ v.name }}
                </div>
              </van-col>
            </van-row>
          </div>
        </van-tab>

        <van-tab title="电台动态">
          <div class="items">
            <van-row
              type="flex"
              class="item van-hairline--top-bottom"
              v-for="(v, k) in dongtais"
              :key="k"
              @click="redirect(v.url)"
            >
              <van-col span="8" class="left">
                <van-image lazy-load fit="cover" :src="v.src"></van-image>
              </van-col>
              <van-col span="16" class="right">
                <div class="title">
                  {{ v.name }}
                </div>
              </van-col>
            </van-row>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Swipe,
  SwipeItem,
  Lazyload,
  Image as VanImage,
  Grid,
  GridItem,
  Tab,
  Tabs,
} from "vant";
import { redirect } from "@/utils/common";
Vue.use(Lazyload, VanImage);

export default {
  data() {
    return {
      active: 0,
      topImages: [
        {
          src: "https://i.tmuyun.com/webpic/W0202210/W020221017/W020221017637834399222.jpg",
          url: "https://fhbmchgo.tp.tmuact.com/new_vote?q=YunSLfB10",
        },
        {
          src: "https://i.tmuyun.com/webpic/W0202204/W020220427/W020220427566933358573.jpg",
          url: "https://app.tmuyun.com/webDetails/subject?id=1368955&tenantId=3",
        },
        {
          src: "https://i.tmuyun.com/webpic/W0202204/W020220427/W020220427566933018069.jpg",
          url: "https://app.tmuyun.com/webDetails/subject?id=1368892&tenantId=3",
        },
      ],
      programs: [
        {
          src: "https://i.tmuyun.com/webpic/W0202209/W020220921/W020220921595553486082.png",
          url: "https://m.qtfm.cn/share/channels/4567?qtsrc=appshare_weixin",
          name: "在线电台",
        },
        {
          src: "https://i.tmuyun.com/webpic/W0202209/W020220921/W020220921595553736036.png",
          url: "https://app.tmuyun.com/webDetails/subject?id=1299559&tenantId=3",
          name: "上学路上",
        },
        {
          src: "https://i.tmuyun.com/webpic/W0202209/W020220921/W020220921595552903863.png",
          url: "https://app.tmuyun.com/webDetails/subject?id=1368574&tenantId=3",
          name: "对话1036",
        },
        {
          src: "https://i.tmuyun.com/webpic/W0202209/W020220921/W020220921595552613272.png",
          url: "https://app.tmuyun.com/webDetails/sonPage?id=1368411&tenantId=3&groupId=121055",
          name: "朗读者",
        },
        {
          src: "https://i.tmuyun.com/webpic/W0202209/W020220921/W020220921595553215269.png",
          url: "https://app.tmuyun.com/webDetails/sonPage?id=1368427&tenantId=3&groupId=121056",
          name: "老丁头讲白搭",
        },
        {
          src: "https://i.tmuyun.com/webpic/W0202209/W020220921/W020220921595552230768.png",
          url: "https://app.tmuyun.com/webDetails/subject?id=1423294&tenantId=3",
          name: "童言说文明",
        },
        {
          src: "https://i.tmuyun.com/webpic/W0202211/W020221103/W020221103439741997140.png",
          url: "https://app.tmuyun.com/webDetails/subject?id=2437247&tenantId=3",
          name: "亲子课堂",
        },
      ],
      activies: [
        {
          src: "https://i.tmuyun.com/webpic/W0202306/W020230616/W020230616624108563393.png",
          url: "https://app.tmuyun.com/webDetails/sonPage?id=4810850&tenantId=3&groupId=157066",
          name: "2023《开讲吧，少年！》"
        },
        {
          src: "https://i.tmuyun.com/webpic/W0202212/W020221212/W020221212407479351156.jpg",
          url: "https://app.tmuyun.com/webDetails/subject?id=2653539&tenantId=3",
          name: "《2022温岭朗读者计划》",
        },
        {
          src: "https://i.tmuyun.com/webpic/W0202211/W020221129/W020221129311955313326.jpg",
          url: "https://app.tmuyun.com/webDetails/sonPage?id=2239217&tenantId=3&groupId=143594",
          name: "《中小学创城故事大赛》",
        },
        {
          src: "https://i.tmuyun.com/webpic/W0202304/W020230427/W020230427329257938155.jpg",
          url: "https://app.tmuyun.com/webDetails/subject?id=1368892&tenantId=3",
          name: "《开讲吧，少年》",
        },
        {
          src: "https://i.tmuyun.com/webpic/W0202204/W020220427/W020220427566933358573.jpg",
          url: "https://app.tmuyun.com/webDetails/subject?id=1368955&tenantId=3",
          name: "《你就是歌手》",
        },
        {
          src: "https://i.tmuyun.com/webpic/W0202210/W020221016/W020221016579746472397.jpg",
          url: "https://vapp.tmuyun.com/webDetails/subject?id=1838021&tenantId=3",
          name: "《爱老助老 情暖温岭》",
        },
      ],
      dongtais: [
      {
          src: "https://img.tmuyun.com/assets/20220623/1655953878156_62b3d9d6b40eef6d7417dbab.png",
          url: "https://app.tmuyun.com/webDetails/news?id=3241083&tenantId=3&uid=6180e93a010ef67ec513a7ba",
          name: "想要当电台主持人吗？FM103.6招募兼职主持啦！！",
        },
        {
          src: "https://i.tmuyun.com/webpic/W0202304/W020230427/W020230427328197604475.jpg",
          url: "https://app.tmuyun.com/webDetails/news?id=1518630&tenantId=3",
          name: "自从认识了这俩活宝，下班路上更快乐了！",
        },
      ],
    };
  },
  created() {
    let startTime = new Date("2022/10/18 00:00:00").getTime();
    // let endTime = new Date("2022/11/21 00:00:00").getTime();
    let nowTime = new Date().getTime();

    if (nowTime >= startTime) {
      this.topImages = [
        {
          src: "https://i.tmuyun.com/webpic/W0202212/W020221212/W020221212407479351156.jpg",
          url: "https://mp.weixin.qq.com/s/y2saEM317cUUlnBTDhDO_g",
        },
      ];
    }
  },
  methods: {
    redirect,
  },
};
</script>

<style lang="less" scoped>
.dianbo {
  margin-top: 10px;
  .title {
    border-left: 3px solid rgb(35, 117, 224);
    padding-left: 10px;
  }

  .items {
    margin-top: 10px;
    .item {
      // border: 1px solid red;
      .name {
        font-size: 12px;
        text-align: center;
      }
    }
  }
}

.activity {
  .items {
    margin-top: 10px;
    .item {
      padding-bottom: 20px;
      .right {
        padding-left: 5px;
      }
    }
  }
}
</style>